import { Typography } from "@mui/material";
import { hmLightTheme } from "../themes/hmTheme";

const HeaderTableLabelValue = ({ ...props }) => {
  const isCalValue = props.isCalValue;
  // let fontFamily = props.fontFamily ? props.fontFamily : "Proxima Nova";
  let fontFamily =
    props.fontFamily == "numberFontFamily"
      ? hmLightTheme?.palette?.numberFontFamily || "Proxima Nova"
      : hmLightTheme?.palette?.textFontFamily || "Proxima Nova";
  if (props.type == "link") {
    return (
      <Typography
        variant="body2"
        color="textSecondary"
        component="a"
        href={props.linkto}
        target="_blank"
        rel="noreferrer"
        sx={{
          color: isCalValue ? "#5b9bd5" : "black",
          fontSize: "0.875rem",
          p: 1,
        }}
      >
        <span style={{ fontFamily: fontFamily }}>{props.value}</span>
      </Typography>
    );
  } else {
    return (
      <Typography
        variant="body2"
        color="textSecondary"
        sx={{
          color: isCalValue ? "#5b9bd5" : "black",
          fontSize: "0.875rem",
          p: 1,
        }}
      >
        <span style={{ fontFamily: fontFamily }}>{props.value}</span>
      </Typography>
    );
  }
};

export default HeaderTableLabelValue;
